import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'CampSessionGroup';

const CampSessionGroupApi: any = baseApi(endpoint);

export default CampSessionGroupApi;